window.addEventListener('load', function() {
    const loader = document.getElementById('loader');
    
    if(loader) {
        // 🌟 ここで秒数をコントロールします！
        // 2500 = 2.5秒、3000 = 3秒。カンプの雰囲気を見て変えてみてね。
        const displayTime = 2500; 
        
        setTimeout(function() {
            loader.classList.add('loaded');
        }, displayTime);
    }
});

// ==========================================================================
// 🍔 ハンバーガーボタンをクリックした時（安全ガード付きにアップデート！）
// ==========================================================================
const hamburgerBtn = document.querySelector('.hamburger-btn');
const globalNav = document.querySelector('.global-nav');

// 🌟【超重要】画面にボタンとナビが「両方とも存在するときだけ」中身を実行するお守り
if (hamburgerBtn && globalNav) {
    
    // ボタンとメニューの開閉（トグル）
    hamburgerBtn.addEventListener('click', function() {
        this.classList.toggle('active');
        globalNav.classList.toggle('is-active');
    });

    // メニュー内のすべてのaタグ（リンク）を取得する
    const navLinks = document.querySelectorAll('.global-nav a');

    // 全てのリンクに対して「クリックされた時の処理」をつける
    navLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            hamburgerBtn.classList.remove('active');
            globalNav.classList.remove('is-active');
        });
    });
}

// ==========================================================================
// 📸 メインキービジュアルスライダー（Slickの設定）
// ==========================================================================
$('.slider-area').slick({
    autoplay: true,         // 💡 自動でスライドさせる
    autoplaySpeed: 3000,    // 💡 次のスライドに切り替わるまでの時間（3秒）
    speed: 1000,            // 💡 切り替わるときのアニメーションの速度（1秒かけて滑らかに）
    dots: true,             // 💡 下側に「現在位置を表すドット（丸ぽち）」を表示
    arrows: false,          // 💡 左右の「前の画面へ/次の画面へ」の矢印は一旦なしに
    fade: true,             // 💡 🌟ここをtrueにすると、横に流れるのではなく「ふわっと優しく切り替わる（フェードイン・アウト）」になります！
});

window.addEventListener('DOMContentLoaded', function() {
    // 💡 フワッとさせたいターゲットをすべて集める
    const targets = document.querySelectorAll('.fade-in-target');
    
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15 // 🌟 コンテンツが15%くらい画面に入ったらスタートする合図
    };
    
    const observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 画面に入ったらクラスをつけてフワッとさせる
                entry.target.classList.add('is-visible');
                // 1度表示されたら、何度もパチパチ動かないように監視を解除する
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    
    targets.forEach(target => {
        observer.observe(target);
    });
});

// ==========================================================================
// 会場イベントスライだー
// ==========================================================================
const eventSwiper = new Swiper('.event-swiper', {
    // 🌟【超重要】これで自動的に横並びになり、隙間なく無限ループ（エンドレス）になります
    loop: true,               
    
    slidesPerView: 2,         // スマホでは2個並び
    spaceBetween: 20,         // アイテム同士の横の隙間
    
    // 🌟 自動で動き続ける設定
    autoplay: {
        delay: 2000,          // 2秒ごとに次のスライドへポンッと動く
        disableOnInteraction: false, // ユーザーが触っても自動再生を止めない
    },
    
    // 🌟 画面幅（PCサイズ）に合わせた表示個数の指示
    breakpoints: {
        768: {
            slidesPerView: 3, // タブレットは3個並び
            spaceBetween: 25,
        },
        1024: {
            slidesPerView: 5, // 🔥 PC画面ではカンプ通りの「5個並び」にする！
            spaceBetween: 30, // PCでのアイテム同士の心地いい隙間
        }
    }
});

// ==========================================================================
// ニュースもっと見るボタンの動き
// ==========================================================================
document.querySelectorAll('.news-item-visible').forEach(item => {
    item.addEventListener('click', () => {
        // クリックされたアイテムの親（.news-item）を捕まえる
        const parent = item.parentElement;
        
        // 「is-open」クラスをつけたり外したりする
        parent.classList.toggle('is-open');
    });
});

// ==========================================================================
// トピックスもっと見るイベント
// ==========================================================================
const topicsBtn = document.querySelector('.info-column-left .custom-btn-link');
const topicsContent = document.querySelector('.topics-content');

if (topicsBtn && topicsContent) {
    topicsBtn.addEventListener('click', (e) => {
        e.preventDefault(); // 画面が一番上にピョコッと戻るのを防ぐお守り
        
        // 「is-open」クラスをつけたり外したりする
        topicsContent.classList.toggle('is-open');
        
        // ボタンの文字も「もっと見る」と「閉じる」で切り替える（地味に嬉しい演出）
        const btnText = topicsBtn.querySelector('.btn-text');
        if (topicsContent.classList.contains('is-open')) {
            btnText.textContent = '閉じる';
        } else {
            btnText.textContent = 'もっと見る';
        }
    });
}

// ==========================================================================
// 🎪 event.htmlモーダル（ポップアップ詳細）をシュパッと開閉する処理（div完全対応版！）
// ==========================================================================
const modalButtons = document.querySelectorAll('.event-btn-item');

modalButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
        // ボタンの「data-modal」に書かれているIDを取得
        const targetModalId = this.getAttribute('data-modal');
        const targetModal = document.getElementById(targetModalId);
        
        // 💡 htmlが <a> ではなく <div> になったので、event.preventDefault() などの不要な命令を消去！
        // 純粋に「is-open」クラスを付与するだけの超安全・軽量な動きにします
        if (targetModal) {
            targetModal.classList.add('is-open');
        }
    });
});

// ❌ 閉じるボタン（×）を押した時の処理
const closeButtons = document.querySelectorAll('.modal-close-btn');

closeButtons.forEach(function(closeBtn) {
    closeBtn.addEventListener('click', function() {
        const modal = this.closest('.modal-overlay');
        if (modal) {
            modal.classList.remove('is-open'); // クラスを外して隠す
        }
    });
});

// 🌫️ モーダルの背景（黒い透過部分）をクリックしても閉じれる優しい設計
const modalOverlays = document.querySelectorAll('.modal-overlay');

modalOverlays.forEach(function(overlay) {
    overlay.addEventListener('click', function(event) {
        if (event.target === this) {
            this.classList.remove('is-open');
        }
    });
});